const fetchPageData = async ({ lang }) => {
  const langString = lang === 'de' ? '/de' : '';

  const url = `https://eyefitu.ch${langString}/wp-json/wp/v2/pages?slug=news`;

  const response = await fetch(url);

  const [item] = await response.json();

  const title = item.title.rendered;
  const { meta } = item;

  return { title, meta };
};

const fetchNews = async ({ lang }) => {
  const langString = lang === 'de' ? '/de' : '';

  const url = `https://eyefitu.ch${langString}/wp-json/wp/v2/news?per_page=100`;

  const response = await fetch(url);

  const json = await response.json();

  return json;
};

const fetchData = async ({ lang }) => {
  const [page, collection] = await Promise.all([
    fetchPageData({ lang }),
    fetchNews({ lang }),
  ]);

  return {
    page,
    collection,
  };
};

export default fetchData;
